<app-dynamic-text-widget [config]="config" [text]="date | momentp: 'D MMM YY'"></app-dynamic-text-widget>
